import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  ...Common,
};
